import { ChangeEvent } from "react";

export interface FileInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange"> {
  label: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  errorText?: string;
}

export const FileInput = ({
  id,
  name,
  label,
  onChange,
  required,
  errorText,
  className,
  ...restProps
}: FileInputProps) => {
  const error = Boolean(errorText);
  const color = error ? "failure" : "";

  return (
    <div className="mb-4">
      {label && (
        <div className="mb-2 block">
          <label
            htmlFor={name}
            className="block mb-2 text-sm font-semibold text-gray-900 dark:text-white"
          >
            {label} {required ? <span className="text-red-500">*</span> : ""}
          </label>
        </div>
      )}
      <input
        id={name}
        type="file"
        onChange={onChange}
        color={color}
        className={`bg-border border-0 text-gray-900 text-sm rounded-md block w-full p-1 outline-none focus:ring-0 focus:ring-offset-0 focus:ring-border focus:border-0`}
        {...restProps}
      />
      {errorText && <p className="text-xs text-red-500 mt-1">{errorText}</p>}
    </div>
  );
};
